import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/service/toaster/notification.service';
declare let $: any;
@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss']
})
export class TemplatesComponent implements OnInit {

  addTemplateForm: FormGroup;
  loading;
  submittedTemplate = false;
  constructor(private notifyService: NotificationService,
              private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.policyFields();
  }

      // tslint:disable-next-line: typedef
 get policyErrorMsg() { return this.addTemplateForm.controls; }

  policyFields(): void {
    this.addTemplateForm = this.formBuilder.group({
     pol_name: ['', Validators.required],
     briefurl: ['', Validators.required],
     effct_date: ['', Validators.required],
     upld_pol: ['']
    });
  }

  onClosePolicy(): void {
    this.submittedTemplate = false;
    this.addTemplateForm.reset();
  }

  openModal(id): void {
    $(id).modal('show');
  }

  onSubmitTemplate(): void {
    this.submittedTemplate = true;
  }
}
